import React from 'react';
import { SITE } from '../config/site';

export default function TopBar() {
  const phone = SITE.phones[0];
  return (
    <div className="top-bar">
      <div className="top-bar-inner">
        <div className="top-bar-contact">
          <a href={`tel:+57${phone}`}>
            <svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor" aria-hidden>
              <path d="M6.6 10.8a15.5 15.5 0 006.6 6.6l2.2-2.2a1 1 0 011-.24c1.1.37 2.3.56 3.5.56a1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.2.19 2.4.56 3.5a1 1 0 01-.25 1L6.6 10.8z" />
            </svg>
            {phone}
          </a>
          <a href={`mailto:${SITE.email}`}>
            <svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor" aria-hidden>
              <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 4l-8 5L4 8V6l8 5 8-5v2z" />
            </svg>
            {SITE.email}
          </a>
        </div>
        <div className="top-bar-social">
          <a href={SITE.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden>
              <path d="M13.5 22v-8h2.6l.4-3h-3V9.2c0-.9.3-1.5 1.6-1.5H16.7V5.1C16.3 5 15.2 5 14 5c-2.5 0-4.2 1.5-4.2 4.3V11H7.5v3h2.3v8h3.7z" />
            </svg>
          </a>
          <a href={SITE.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden>
              <path d="M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4zm5 4.5A4.5 4.5 0 1 0 16.5 12 4.5 4.5 0 0 0 12 7.5zm5.8-.9a1.1 1.1 0 1 0 1.1 1.1 1.1 1.1 0 0 0-1.1-1.1zM12 9.2A2.8 2.8 0 1 1 9.2 12 2.8 2.8 0 0 1 12 9.2z" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}
